import { render } from "./ListGroups.vue?vue&type=template&id=66f77748&ts=true"
import script from "./ListGroups.vue?vue&type=script&lang=ts"
export * from "./ListGroups.vue?vue&type=script&lang=ts"

import "./styles/Groups.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__